import { render, staticRenderFns } from "./stadium_map.vue?vue&type=template&id=366baf4e&"
import script from "./stadium_map.vue?vue&type=script&lang=ts&"
export * from "./stadium_map.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports